// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aLl68","col":"styles_col__2kAlY","actions":"styles_actions__BMgnZ","conflict":"styles_conflict__2defl"};